import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';

const getLimit = store => async state => {
    try {
        const userClientId = state.user.selectedUserClientId;
        const clientId = state.user.selectedClientId;

        // Sets filters as loading
        const loadingState = R.assocPath(
            ['clients', userClientId, 'pacing', 'isLoadingLimit'],
            true,
            state,
        );

        store.setState(loadingState);

        const [goals, { limit = 8 }] = await Promise.all([
            sportsApi
                .url(`/clients/${clientId}/goals`)
                .json({
                    action: 'fetchQuery',
                })
                .post()
                .json(),
            sportsApi
                .url(`/clients/${clientId}/goals/limit`)
                .get()
                .json(),
        ]);

        const currentGoals = goals.filter(g => !g.archived);
        const availableGoalCount = limit
            ? currentGoals.length < limit
                ? limit - currentGoals.length
                : 0
            : null;

        store.setState(
            R.evolve(
                {
                    clients: {
                        [userClientId]: {
                            pacing: {
                                isLoadingLimit: R.F,
                                limit: R.always(limit),
                                availableGoalCount: R.always(
                                    availableGoalCount,
                                ),
                            },
                        },
                    },
                },
                store.getState(),
            ),
            true,
        );
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

export default getLimit;
